import React, { useMemo, useState } from 'react';
import { WTitle, CTitle, LeftIcon, RightIcon } from '../../components/Widget';
import FileRightImg from '@/assets/2025/topic1400/file_right_img.png';
import FileLeftPerson from '@/assets/2025/topic1400/file_left_person.png';
import SharedLeftBottom from '@/assets/2025/topic1400/shared_left_bottom.png';
import ImgPoint from '@/assets/2025/arrow.gif';
import { useParams } from 'react-router-dom';
// import { useStore } from '../../../../store';
import { useUpdateComponentState } from '../../../hooks';

interface ISection3Props {
  settings: any;
}

const Section3: React.FunctionComponent<ISection3Props> = ({ settings }) => {
  const ID = '4';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  // const { updateParagraphState } = useStore();
  const [active, setActive] = useState(0);
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[3],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  const [state, setState] = useState({
    clickSlide: 1,
  });
  const goToNextSlide = () => {
    if (active < 1) {
      setActive(active + 1);
      setState({ clickSlide: state.clickSlide - 1 });
    }
  };
  const goToPreviousSlide = () => {
    if (active > 0) {
      setActive(active - 1);
    }
  };
  React.useEffect(() => {
    if (state.clickSlide === 0) {
      updateComponentState(p_course, p_topic, ID, '2025-topic1400-section3-1');
      // updateParagraphState(p_course, p_topic, ID, 'completed', []);
    }
  }, [state.clickSlide]);
  return (
    <div className="topic-section-4">
      <WTitle title={paragraphsSettings?.title} />
      <div className="case">
        <img className="fileLeftPerson" src={FileLeftPerson} alt="" />
        <div className="subTitle">
          <span>{paragraphsSettings?.caseTitle}</span>
        </div>
        <div className="case-content">
          <div className="case-content-left">
            <p>{paragraphsSettings?.l1}</p>
            <p>{paragraphsSettings?.l2}</p>
            <div className="link-text">
              {paragraphsSettings?.linkText}
              <br />
              <a
                href="https://www.pcpd.org.hk/english/news_events/media_statements/press_20260515.html​"
                target="_blank"
                rel="noreferrer"
              >
                {paragraphsSettings?.linkName}
              </a>
            </div>
          </div>
          <img className="case-content-right" src={FileRightImg} alt="" />
        </div>
      </div>
      <CTitle title={paragraphsSettings?.fileTitle1} />
      <div className="file-subtitle">{paragraphsSettings?.fileSubtitle}</div>
      <div
        id="2025-topic1400-section3-1"
        className={`file-content file-content${active}`}
      >
        <img src={SharedLeftBottom} alt="" />
        <div className="word-l0 word-l1">
          {paragraphsSettings?.shareList?.[active]?.l1}
          <h3>01</h3>
        </div>
        <div className="word-l0 word-l2">
          {paragraphsSettings?.shareList?.[active]?.l2}
          <h3>02</h3>
        </div>
        <div className="word-l0 word-l3">
          <h3>03</h3>
          {paragraphsSettings?.shareList?.[active]?.l3}
        </div>
        <div className="file-content-center">
          <div
            className="center-word"
            dangerouslySetInnerHTML={{
              __html: paragraphsSettings?.shareList?.[active]?.l0,
            }}
          />
        </div>
      </div>
      <div className="file-content-action">
        {state.clickSlide === 1 && (
          <img className="imgPoint" src={ImgPoint} alt="" />
        )}
        <span onClick={goToPreviousSlide}>
          <LeftIcon fill={active === 0 ? '#A8A8A8' : '#FE5506'} />
        </span>
        <span onClick={goToNextSlide}>
          <RightIcon fill={active === 1 ? '#A8A8A8' : '#FE5506'} />
        </span>
      </div>
    </div>
  );
};

export default Section3;
